import styled from 'styled-components';
import { colors } from "colors";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 4px;
  box-shadow: 1px 1px 4px 1px ${colors.paleGrey};
  margin: 16px 0;
  cursor: pointer;
`;

export const PanelTitleWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  height: 48px;
  box-shadow: 0 1px 0 0 ${colors.paleGrey};
  font-size: 14px;

  >:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    flex-flow: row wrap;
    flex: 1;

    span {
      display: flex;
      width: 320px;
    }

    span>:first-child {
      flex: 0.35;
      text-align: end;
    }

    span>:last-child {
      flex: 0.65;
    }
  }
`;

export const PurchaseOrderStatus = styled.p`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-weight: bold;

  span.circle {
    display: inline-block;
    border-radius: 16px;
    padding: 8px;
    margin: 0 8px 0 0;
  }

  &.awaiting {
    color: ${colors.darkMustard};
  }
  span.circle.awaiting {
    background-color: ${colors.darkMustard};
  }

  &.partially-fulfilled {
    color: ${colors.brightBlue};
  }
  span.circle.partially-fulfilled {
    box-sizing: border-box;
    box-shadow:0 0 0 2px ${colors.brightBlue} inset;
    background-color: ${colors.white};
  }

  &.approved {
    color: ${colors.jungleGreen};
  }
  span.circle.approved {
    background-color: ${colors.jungleGreen};
  }

  &.declined {
    color: ${colors.strawberry};
  }
  span.circle.declined {
    background-color: ${colors.strawberry};
  }

  &.fulfilled {
    color: ${colors.brightBlue};
  }
  span.circle.fulfilled {
    background-color: ${colors.brightBlue};
  }
`;

export const PanelContentWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-flow: row wrap;
  flex-direction: row;
`;

export const ColumnWrapper = styled.span`
  display: flex;
  flex-flow: row wrap;
  flex: ${props => props.max ? 1: 0};
`;

export const RequestNumberWrapper = styled.span`
  display: flex;
  flex-shrink: 1;
  p, span {
    margin: 0 0 8px 0;
    border-radius: 4px;
    background-color: #f1f5f6;
    padding: 8px;
    height: 16px;
    text-align: center;
    color: #878c90;
  }
`;

export const RequestInfoWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  padding: 0 16px;
  min-width: 256px;
  
  font-size: 14px;
  color: ${colors.charcoalGrey};

  > div {
    display: flex;
    flex-direction: column;
    padding: 2px 8px;

    span:first-child {
      font-weight: bold;
    }

    span:last-child {
      margin-top: 4px;
    }
  }

  >:first-child {
    min-width: 256px;
  }
`;

export const Label = styled.span`
  font-weight: bold;
  color: ${colors.charcoalGrey};
  p {
    margin: 0;
  }
  span, a {
    font-weight: normal;
    margin-left: 16px;
  }
`;
